import { render, staticRenderFns } from "./InventoryItemPanel.vue?vue&type=template&id=54ed1dce"
import script from "./InventoryItemPanel.vue?vue&type=script&lang=js"
export * from "./InventoryItemPanel.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemPanel.vue?vue&type=style&index=0&id=54ed1dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports